var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":"PO Return Approval Requests"}},[_c('div',{staticClass:"flex vx-input-group"},[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Waiting"}},[_c('tab-waiting')],1),_c('vs-tab',{attrs:{"label":"Approved"}},[_c('tab-approved')],1),_c('vs-tab',{attrs:{"label":"Rejected"}},[_c('tab-rejected')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }